import { ReviewFinish } from '.';
import { EnvironmentTypesEnum } from '../helpers';
import { useState } from 'react';
import { useAdoProjectCreation } from '../hooks/useAdoProjectCreation';
import { useCreateProject, useEnvironmentCreation } from '../hooks';

const { EH } = EnvironmentTypesEnum;

export const ADOReviewFinish: React.FC<{
	token: string;
	isLoading: boolean;
}> = ({ token, isLoading: initialLoading }) => {
	const { isByoc, isSingleEnvironmentCreation, values } = useCreateProject();
	const [isCmEnvironmentSuccess, setIsCmEnvironmentSuccess] = useState(false);
	const [detail, setDetail] = useState({
		cmEnvironmentId: '',
		projectId: '',
	});

	function onCmEnvironmentCreationSuccess(
		cmEnvironmentId: string,
		projectId: string,
	) {
		setDetail({ cmEnvironmentId, projectId });
		setIsCmEnvironmentSuccess(true);
		onEnvironmentLevelProcess(projectId, cmEnvironmentId);
	}

	const {
		isLoading: isGitHubProjectCreationLoading,
		onHandleCreationProcess,
		repositoryCreationStatus: cmRepositoryCreationStatus,
		projectCreationStatus: cmProjectCreationStatus,
		environmentCreationStatus: cmEnvironmentCreationStatus,
		deploymentCreationStatus: cmDeploymentCreationStatus,
		environmentVariableCreationStatus: cmEnvironmentVariableCreationStatus,
		shouldRetry,
	} = useAdoProjectCreation({
		token,
		onCmEnvironmentCreationSuccess,
	});

	const {
		isLoading: isLoadingCreateEnvironment,
		onEnvironmentLevelProcess,
		environmentCreationStatus: ehEnvironmentCreationStatus,
		deploymentCreationStatus: ehDeploymentCreationStatus,
		environmentVariableCreationStatus: ehEnvironmentVariableCreationStatus,
	} = useEnvironmentCreation({
		shouldGoto: true,
		environmentType: EH,
	});

	const listOfStatus = [
		...(isByoc
			? []
			: [
					{
						status: cmRepositoryCreationStatus,
						text: `Repository`,
					},
				]),

		{ status: cmProjectCreationStatus, text: `Project` },
		{
			status: cmEnvironmentCreationStatus,
			text: `Authoring environment`,
		},
		{
			status: cmDeploymentCreationStatus,
			text: `Authoring environment deployment`,
		},
		...(values.cmEnvironmentVariables.length
			? [
					{
						status: cmEnvironmentVariableCreationStatus,
						text: `Authoring environment variables`,
					},
				]
			: []),
		...(isSingleEnvironmentCreation
			? []
			: [
					{
						status: ehEnvironmentCreationStatus,
						text: `Editing host`,
					},
					{
						status: ehDeploymentCreationStatus,
						text: `Editing host deployment`,
					},
					...(values.ehEnvironmentVariables.length
						? [
								{
									status: ehEnvironmentVariableCreationStatus,
									text: `Editing host variables`,
								},
							]
						: []),
				]),
	];
	const startCreateProject = () => {
		!isCmEnvironmentSuccess && onHandleCreationProcess();
		const { cmEnvironmentId, projectId } = detail;
		isCmEnvironmentSuccess &&
			onCmEnvironmentCreationSuccess(cmEnvironmentId, projectId);
	};

	const isLoading =
		isLoadingCreateEnvironment ||
		isGitHubProjectCreationLoading ||
		initialLoading;

	return (
		<ReviewFinish
			{...{
				isLoading,
				shouldRetry,
				handleStartDeployment: startCreateProject,
				listOfStatus,
			}}
		/>
	);
};
